<template lang="pug">
  .section-layout
    .nav-back-btn(@click="$router.go(-1)")
    .content-wrapper
      h2 预约详情
      .info
        .list
          .item(v-for='item,index in list' :key="index")
            .title {{item.title}}
            .content
              .text(v-if="item.type=='date'") {{item.content | formatDate}}
              .text(v-else) {{item.content}}
</template>
<script>
export default {
  name: 'AppointmentDetail',
  data () {
    return {
      list: [
        {
          title: '客户姓名',
          content: '--',
        },
        {
          title: '手机号码',
          content: '--',
        },
        {
          title: '预约时间',
          content: '--',
          type: 'date',
        },
        {
          title: '预约门店',
          content: '--',
        },
        {
          title: '自定义内容',
          content: '--',
        },

      ],
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.init()
  },
  methods: {
    init () {
      if (sessionStorage.getItem('appointmentDetail')) {
        let values = Object.values(JSON.parse(sessionStorage.getItem('appointmentDetail')))
        values.forEach((i, index) => {
        // if (index >= 4) return
          this.list[index].content = i
        })
      } else {
        this.$message.error('请检查数据')
      }
    },
  },
  filters: {
    formatDate (t) {
      if (!t) return '暂无'
      t = new Date(t * 1000)
      let Y = t.getFullYear()
      let M = t.getMonth() + 1
      let D = t.getDate()
      let h = t.getHours()
      let mm = t.getMinutes()
      let s = t.getSeconds()
      M = M < 10 ? '0' + M : M
      D = D < 10 ? '0' + D : D
      h = h < 10 ? '0' + h : h
      mm = mm < 10 ? '0' + mm : mm
      s = s < 10 ? '0' + s : s
      return `${Y}-${M}-${D} ${h}:${mm}:${s}`
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~@/stylus/modules/creation-modal';
.nav-back-btn
  position absolute
  top 36px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.info
  width 100%
  height 100%
  padding: 20px 40px
  .list
    .item
      line-height 160%
      display flex
      font-size 14px
      margin-bottom 15px
      .title
        min-width: 100px 
        color: #222
        margin-right 20px
      .content
        max-width: 600px
        color: #747474
        

</style>


// WEBPACK FOOTER //
// src/components/workbench/components/AppointmentDetail.vue